import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../providers/AuthProvider";
import RouteFallback from "../fallback/RouteFallback";

export default function ProtectedRoute() {
  const { isAuthenticated, status } = useAuth();

  if (status === "booting") return <RouteFallback />;

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
